module.exports = __webpack_public_path__ + "static/img/jordan-river-wayfinding-signs07.8986d9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/jordan-river/jordan-river-wayfinding-signs07.jpg
// module id = 922
// module chunks = 0